<template>
    <ThePage>
        <div class="d-flex flex-column flex-lg-row">
            <div class="vm-state-counters d-flex flex-row flex-lg-column">
                <div class="card">
                    <div class="card-body text-muted">
                        <div class="counter">{{ dashboard.count_vm_online }}</div>
                        <small class="text-nowrap">ТА онлайн</small>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body text-muted">
                        <div class="counter">{{ dashboard.count_vend_24h }}</div>
                        <small class="text-nowrap">Продаж за сутки</small>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body text-muted">
                        <div class="counter">{{ dashboard.count_crt_24h }}</div>
                        <small class="text-nowrap">Чеков за сутки</small>
                    </div>
                </div>
            </div>

            <div class="flex-lg-fill ml-lg-3 mt-lg-0 mt-3 mt-lg-0">
                <div class="card mb-3 d-none d-sm-block">
                    <div class="card-body card-body-search">
                        <input :value="filter.search" type="text" class="form-control form-control-search" placeholder="Быстрый поиск" @input="search">
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th v-sort:id>#</th>
                                    <th v-sort:name class="w-25">Компания</th>
                                    <th class="w-25">Пользователь</th>
                                    <th v-sort:vms_count>ТА</th>
                                    <th v-sort:modems_count>Модемы</th>
                                    <th>Статус</th>
                                    <th v-sort:balance>Баланс</th>
                                    <th class="text-center">Реквизиты</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="company in companies" :key="company.id">
                                    <td>
                                        <router-link :to="{ name: 'admin.company', params: { id: company.id }}">{{ company.id }}</router-link>
                                    </td>
                                    <td>
                                        <router-link :to="{ name: 'admin.company', params: { id: company.id }}">{{ company.name || 'Компания без названия' }}</router-link>
                                    </td>
                                    <td>
                                        <template v-if="company.user_id">
                                            <span v-show="company.user_first_name && company.user_last_name">
                                                {{ company.user_first_name }} {{ company.user_last_name }},
                                            </span>
                                            {{ company.user_email }}
                                        </template>

                                        <template v-else>
                                            <span class="text-danger">Нет пользователей</span>
                                        </template>
                                    </td>
                                    <td>{{ company.vms_count }}</td>
                                    <td>{{ company.modems_count }}</td>
                                    <td>{{ company.state | companyStateText | nodata }}</td>
                                    <td>{{ company.balance | nodata }} {{ company.balance_currency | currencySymbol | nodata }}</td>
                                    <td class="text-center">
                                        <i v-if="company.is_verified" class="tlm-icon-check-circle text-success" />
                                        <i v-else-if="company.requisites.inn && !company.is_verified" class="tlm-icon-spinner text-danger" />
                                    </td>
                                </tr>
                            </tbody>

                            <tfoot v-if="companies.length === 0" class="no-one">
                                <tr>
                                    <td colspan="42">Ни одной компании не найдено.</td>
                                </tr>
                            </tfoot>
                        </table>

                        <div class="d-flex flex-row flex-wrap justify-content-between align-items-center">
                            <span />
                            <pagination v-show="meta && meta.last_page > 1" :meta="meta" class="pagination" @input="applyFilter({ page: $event })" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ThePage>
</template>

<script>
import debounce from 'lodash/debounce'

import store from '@/store'
import adminStoreModule from '@/store/modules/admin'

import Pagination from '@/components/Pagination'
import ThePage from '@/components/ThePage'

if (!store.state['admin']) {
    store.registerModule('admin', adminStoreModule)
}

export default {
    components: {
        ThePage,
        Pagination
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({ })
        }
    },

    computed: {
        dashboard() {
            return store.state.admin.dashboard
        },

        companies() {
            return store.state.admin.companies.data || []
        },

        meta() {
            return store.state.admin.companies.meta || {}
        }
    },

    methods: {
        search: debounce(function (e) {
            this.applyFilter({ page: 1, search: e.target.value })
        }, 1200)
    },

    async beforeRouteEnter(to, from, next) {
        await Promise.all([
            store.dispatch('admin/companies/fetchAll', to.query),
            store.dispatch('admin/fetchDashboard')
        ])

        next()
    },

    async beforeRouteUpdate(to, from, next) {
        await Promise.all([
            store.dispatch('admin/companies/fetchAll', to.query)
        ])

        next()
    }
}
</script>
